module.exports = __webpack_public_path__ + "static/img/about-1-Overview-img-6.3a605bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about-1-Overview-img-6.jpg
// module id = tJB0
// module chunks = 0